import { render, staticRenderFns } from "./LoadingListCard.vue?vue&type=template&id=458c4083"
import script from "./LoadingListCard.vue?vue&type=script&lang=ts"
export * from "./LoadingListCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('458c4083')) {
      api.createRecord('458c4083', component.options)
    } else {
      api.reload('458c4083', component.options)
    }
    module.hot.accept("./LoadingListCard.vue?vue&type=template&id=458c4083", function () {
      api.rerender('458c4083', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/loading-templates/LoadingListCard.vue"
export default component.exports